/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { VideosState } from 'redux/videos/typings'
import { onLogout } from 'redux/loginInfo/loginInfoSlice'
import { getVideos } from './thunks'

export const initState: VideosState = {
  status: 'initial',
  videoListAccountType: '',
  response: null,
  error: null
}

const videosSlice = createSlice({
  name: 'videos',
  initialState: initState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getVideos.pending, state => {
        state.status = 'pending'
      })
      .addCase(getVideos.fulfilled, (state, { payload }) => {
        state.status = 'success'
        state.response = payload.response

        /*
         * Use ternary because value cannot be 'generic'. No such thing as a
         * 'generic' video list configuration file
         */
        state.videoListAccountType =
          payload.videoListAccountType === 'prox' ? 'prox' : 'brc'
      })
      .addCase(getVideos.rejected, (state, { payload }) => {
        state.status = 'error'
        state.error = payload
      })
      .addCase(onLogout, () => initState)
  }
})

const { reducer } = videosSlice

export default reducer
